import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

interface PartnerState {
  partners: string[];
  loading: boolean;
  error: string | null;
}

const initialState: PartnerState = {
  partners: [],
  loading: false,
  error: null,
};

// API Call
export const fetchPartnerTypes = createAsyncThunk(
  "partners/fetchPartnerTypes",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get(
        `/api/partners/types`
      );
      
      return res.data.data; // important change
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Error fetching partners"
      );
    }
  }
);

const partnersSlice = createSlice({
  name: "partners",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPartnerTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPartnerTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.partners = action.payload;
      })
      .addCase(fetchPartnerTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default partnersSlice.reducer;